import {
  Button,
  Content,
  FileUploadButton,
  ContentLayout,
  ListTable,
  Img,
  SortableRow,
  InputBox,
} from "@adminComponents";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {adminApi} from "@utils";
import * as Datas from "@adminData";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

const OTHER_TYPE = ["B", "C", "D", "E", "F", "G", "H", "I", "J"];

export default function Page() {
  const [aList, setAList] = useState<Datas.IAdvResponse[]>([]);
  const [data, setData] = useState<Datas.IAdvResponse[]>([]);

  const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

  const handleDragEnd = async (event: DragEndEvent) => {
    const {active, over} = event;
    if (!over) return;
    if (active.id === over.id) return;

    const oldIndex = (aList || []).findIndex(item => item.no === active.id);
    const newIndex = (aList || []).findIndex(item => item.no === over.id);
    const nextList = arrayMove(aList || [], oldIndex, newIndex);
    setAList(nextList);

    // 서버 저장
    try {
      const newSort = nextList.map((item, index) => ({
        no: item.no!,
        ordering: index + 1,
      }));
      const {success, message} = await adminApi.adv.sort({
        type: "A",
        data: newSort,
      });
      if (success) {
        //
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("handleDragEnd error", error);
    }
  };

  async function getList() {
    try {
      const {data, success, message} = await adminApi.adv.getList();
      if (success) {
        const a = (data.result || []).filter(item => item.type === "A");
        const other = (data.result || []).filter(item => item.type !== "A");
        console.log(other);
        setAList(a);
        setData(other);
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  async function save(data: {
    type: string;
    no?: number;
    files?: Datas.IFiles[];
  }) {
    try {
      const {success, message} = await adminApi.adv.save(data);
      if (!success) {
        alert(message);
      }
    } catch (error) {
      console.error("save error", error);
    }
  }

  async function edit({no}: {no: number}) {
    try {
      const item = [...(aList || []), ...(data || [])].find(
        _item => _item.no === no,
      );
      if (!no || !item) {
        return;
      }
      const {message} = await adminApi.adv.edit({
        no: item.no!,
        title: item.title,
        content: item.content,
        link: item.link,
      });
      alert(message);
    } catch (error) {
      console.error("edit error", error);
    }
  }

  async function del(data: {no: number}) {
    try {
      if (!confirm("삭제하시겠습니까?")) {
        return;
      }
      const {success} = await adminApi.adv.delete(data);
      if (success) {
        getList();
      }
    } catch (error) {
      console.error("delete error", error);
    }
  }

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <ContentLayout title="광고구좌">
        <Content>
          <div className={styles.content}>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                광고구좌 A
              </div>
              <div className={styles.col}>
                <div>
                  <FileUploadButton
                    text={"업로드"}
                    height={32}
                    width={32}
                    uploadUrl={"/api/v1/upload/adv"}
                    fileUpload={async data => {
                      const newFiles: Datas.IFiles[] = (data.files || [])
                        .slice(0, 1)
                        .map((item, index) => ({
                          url: item,
                          thumb_img_url: (data.thumbList || [])[index],
                        }));
                      await save({type: "A", files: newFiles});
                      getList();
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.row}>
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}>
                <ListTable sortable>
                  <thead>
                    <tr>
                      <th>순서</th>
                      <th>이미지</th>
                      <th>배너정보</th>
                      <th></th>
                    </tr>
                  </thead>
                  <SortableContext
                    items={(aList || []).map(item => String(item.no))}
                    strategy={verticalListSortingStrategy}>
                    <tbody>
                      {(aList || []).length === 0 ? (
                        <tr>
                          <td colSpan={4}>조회된 내용이 없습니다.</td>
                        </tr>
                      ) : (
                        <>
                          {(aList || []).map(item => {
                            const file = item.files?.[0];
                            const img_url = file?.url || file?.thumb_img_url;

                            return (
                              <SortableRow
                                key={item.no}
                                item={{...item, no: item.no!}}
                                format={item => (
                                  <>
                                    <td>
                                      {!!img_url && <Img src={img_url} />}
                                    </td>
                                    <td>
                                      <table className={styles.table}>
                                        <tr>
                                          <th>배너 제목</th>
                                          <td>
                                            <InputBox
                                              value={item?.title}
                                              onValue={value => {
                                                setAList(prev => {
                                                  if (!prev) {
                                                    return prev;
                                                  }
                                                  return [
                                                    ...prev.map(_item => {
                                                      if (
                                                        _item.no === item.no
                                                      ) {
                                                        return {
                                                          ..._item,
                                                          title: value,
                                                        };
                                                      }
                                                      return _item;
                                                    }),
                                                  ];
                                                });
                                              }}
                                              boxStyle={{flex: 1}}
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>배너 내용</th>
                                          <td>
                                            <InputBox
                                              value={item?.content}
                                              onValue={value => {
                                                setAList(prev => {
                                                  if (!prev) {
                                                    return prev;
                                                  }
                                                  return [
                                                    ...prev.map(_item => {
                                                      if (
                                                        _item.no === item.no
                                                      ) {
                                                        return {
                                                          ..._item,
                                                          content: value,
                                                        };
                                                      }
                                                      return _item;
                                                    }),
                                                  ];
                                                });
                                              }}
                                              boxStyle={{flex: 1}}
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>링크URL</th>
                                          <td>
                                            <InputBox
                                              value={item?.link}
                                              onValue={value => {
                                                setAList(prev => {
                                                  if (!prev) {
                                                    return prev;
                                                  }
                                                  return [
                                                    ...prev.map(_item => {
                                                      if (
                                                        _item.no === item.no
                                                      ) {
                                                        return {
                                                          ..._item,
                                                          link: value,
                                                        };
                                                      }
                                                      return _item;
                                                    }),
                                                  ];
                                                });
                                              }}
                                              boxStyle={{flex: 1}}
                                            />
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <div className={styles.btnContainer}>
                                        <Button
                                          text="저장"
                                          onClick={() => edit({no: item.no!})}
                                          backgroundColor={"lightgray"}
                                        />
                                        <Button
                                          text="삭제"
                                          onClick={() => del({no: item.no!})}
                                        />
                                      </div>
                                    </td>
                                  </>
                                )}
                              />
                            );
                          })}
                        </>
                      )}
                    </tbody>
                  </SortableContext>
                </ListTable>
              </DndContext>
            </div>
            <div className={styles.grid}>
              {OTHER_TYPE.map(type => {
                const item = (data || []).find(_data => _data.type === type);
                return (
                  <div className={[styles.col].join(" ")} key={type}>
                    <div className={styles.title}>
                      <span>광고구좌 {type}</span>
                      <div>
                        <FileUploadButton
                          text={"업로드"}
                          height={32}
                          width={32}
                          uploadUrl={"/api/v1/upload/adv"}
                          fileUpload={async data => {
                            const newFiles: Datas.IFiles[] = (data.files || [])
                              .slice(0, 1)
                              .map((item, index) => ({
                                url: item,
                                thumb_img_url: (data.thumbList || [])[index],
                              }));
                            await save({type, files: newFiles});
                            getList();
                          }}
                        />
                      </div>
                    </div>
                    {!!item && (
                      <div>
                        {(item?.files || []).length > 0 && (
                          <div>
                            {(item?.files || []).map(file => {
                              const img_url = file?.url || file?.thumb_img_url;
                              return (
                                <div
                                  key={file.no}
                                  className={styles.imageContainer}>
                                  <Img src={img_url} className={styles.img} />
                                  <div className={styles.btnContainer}>
                                    <div
                                      className={styles.item}
                                      onClick={() => {
                                        const no = item?.no;
                                        if (!no) return;
                                        del({no});
                                      }}>
                                      ❎
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <table className={styles.table}>
                          <tr>
                            <th>배너 제목</th>
                            <td>
                              <InputBox
                                value={item?.title}
                                onValue={value => {
                                  setData(prev => {
                                    if (!prev) {
                                      return prev;
                                    }
                                    return [
                                      ...prev.map(_item => {
                                        if (_item.no === item.no) {
                                          return {
                                            ..._item,
                                            title: value,
                                          };
                                        }
                                        return _item;
                                      }),
                                    ];
                                  });
                                }}
                                boxStyle={{flex: 1}}
                              />
                            </td>
                            <td rowSpan={3}>
                              <Button
                                text="저장"
                                onClick={() => edit({no: item.no!})}
                                backgroundColor={"lightgray"}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>배너 내용</th>
                            <td>
                              <InputBox
                                value={item?.content}
                                onValue={value => {
                                  setData(prev => {
                                    if (!prev) {
                                      return prev;
                                    }
                                    return [
                                      ...prev.map(_item => {
                                        if (_item.no === item.no) {
                                          return {
                                            ..._item,
                                            content: value,
                                          };
                                        }
                                        return _item;
                                      }),
                                    ];
                                  });
                                }}
                                boxStyle={{flex: 1}}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>링크URL</th>
                            <td>
                              <InputBox
                                value={item?.link}
                                onValue={value => {
                                  setData(prev => {
                                    if (!prev) {
                                      return prev;
                                    }
                                    return [
                                      ...prev.map(_item => {
                                        if (_item.no === item.no) {
                                          return {
                                            ..._item,
                                            link: value,
                                          };
                                        }
                                        return _item;
                                      }),
                                    ];
                                  });
                                }}
                                boxStyle={{flex: 1}}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Content>
      </ContentLayout>
    </>
  );
}
